<div>
    <div class="breadcrumbs">
        <button class="back-button" (click)="onCancel()">
            <mat-icon>arrow_back_ios</mat-icon>
            <span class="breadcrumb-text">{{ this.qbuiltConstants.breadcrumbTextHome }}</span>
        </button>
        @if(!this.isEditMode) {
            <span class="breadcrumb-text">{{ this.qbuiltConstants.breadcrumbTextNew }}</span>

        } @else {
            <span class="breadcrumb-text">{{ this.qbuiltConstants.breadcrumbTextEdit }}</span>
        }
    </div>

    <content-panel class="container">
        <panel-body>
            <mat-stepper [linear]="false" #stepper (selectionChange)="onStepperChange($event)" [selectedIndex]="stepperIndex">
            <mat-step [stepControl]="firstFormGroup">
                <form [formGroup]="firstFormGroup" class="first-form">
                    @if(!this.isEditMode) {
                        <ng-template matStepLabel>{{ this.qbuiltConstants.stepperText1 }}</ng-template>
                    } @else {
                        <ng-template matStepLabel>{{ this.qbuiltConstants.stepperTextEdit }}</ng-template>
                    }
                <div class="checklist-details">
                    <div class="checklist-form-item">
                        <span class="info-text">{{ this.qbuiltConstants.checklistTitle }}</span>
                        <mat-form-field>
                            <input matInput placeholder="{{ this.qbuiltConstants.checklistNamePlaceholder }}" formControlName="checklistName" required>
                        </mat-form-field>
                    </div>
                    <div class="checklist-form-item">
                        <span class="info-text">{{ this.qbuiltConstants.commentTitle }}</span>
                        <mat-form-field>
                            <textarea matInput #input placeholder="{{ this.qbuiltConstants.commentPlaceholder }}" formControlName="comments" style="height: 120px;"></textarea>
                            <mat-hint>{{input.value?.length || 0}}/1000</mat-hint>
                        </mat-form-field>
                    </div>
                </div>
                <div class="stepper-button-start">
                    <button class="stepper-button-details" mat-button matStepperNext [disabled]="!firstFormGroup.valid">{{ nextButtonText }}</button>
                </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="secondFormGroup" label="{{this.qbuiltConstants.stepperText2}}">
                <form [formGroup]="secondFormGroup">
                    <div>
                        <item-list-panel [panelType]="1" (stationUpdateEvent)="onStationUpdate($event)" [isEditMode]="isEditMode"></item-list-panel>
                    </div>
                    <div class="stepper-buttons">
                        <button mat-button matStepperPrevious class="stepper-button-details">{{ backButtonText }}</button>
                        <button mat-button matStepperNext class="stepper-button-details" [disabled]="!allRequired">{{ nextButtonText }}</button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="secondFormGroup" label="{{this.qbuiltConstants.stepperText3}}">
                <form [formGroup]="secondFormGroup">
                    <div class="content-container">
                        <item-list-panel [panelType]="2" (stationUpdateEvent)="onStationUpdate($event)" [isEditMode]="isEditMode"></item-list-panel>
                    </div>
                    <div class="stepper-buttons">
                        <button mat-button matStepperPrevious class="stepper-button-details">{{ backButtonText }}</button>
                        <button mat-button matStepperNext class="stepper-button-details">{{ nextButtonText }}</button>
                    </div>
                </form>
            </mat-step>
            <mat-step class="save-page">
                <ng-template matStepLabel>{{ this.qbuiltConstants.stepperText4 }}</ng-template>
                <div class="save-text">
                    <span class="text-item"><b>{{ this.qbuiltConstants.saveTopText }}</b></span>
                    <span class="text-item">{{ this.qbuiltConstants.saveMiddleText }}</span>
                    <span class="text-item"><b>{{ this.qbuiltConstants.saveBottomText }}</b></span>
                </div>
                <div class="stepper-buttons">
                <button mat-button matStepperPrevious class="stepper-button-details">{{backButtonText}}</button>
                <div class="right-hand-buttons">
                    <button mat-button (click)="onCancel()" class="cancel-button">{{ cancelButtonText }}</button>
                    <button mat-button (click)="saveForm(firstFormGroup, secondFormGroup)" class="save-button"
                    [matTooltip]="disableSave() ? this.qbuiltConstants.saveDisabledTooltip : ''"
                    [disabled]="disableSave()">{{ saveButtonText }}</button>
                </div>
                </div>
            </mat-step>
            </mat-stepper>

        </panel-body>
    </content-panel>
</div>